import { render, staticRenderFns } from "./NewScriptDialog.vue?vue&type=template&id=487714b9"
import script from "./NewScriptDialog.vue?vue&type=script&lang=js"
export * from "./NewScriptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports